import React, { useState, useEffect } from "react";
import { Transition } from "@headlessui/react";
import { NavLink, useNavigate } from "react-router-dom";
import { AuthApis } from "../apis/authApis";
import { useDispatch } from "react-redux";
import { login } from "../reducer/loginSlice";
import { useSelector } from "react-redux";
import "react-responsive-modal/styles.css";
import { Modal } from 'react-responsive-modal'
import { useDownloadAppModal } from "../context/DownloadAppModalContext";


function Navbar() {
  const { openDownloadModal } = useDownloadAppModal();
  const [isOpen, setIsOpen] = useState(false);
  const [toggleUserName, setToggleUserName] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [toggleTwo, setToggleTwo] = useState(false);
  const [toggleThree, setToggleThree] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false)
  const [isMenuSubMenu, serMenuSubMenu] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);

  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => {
    if (!logoutLoading) { // Only allow closing if not logging out
      setOpen(false);
    }
  };

  const onOpenDownload = () => {
    openDownloadModal();
    setIsOpen(false); // close mobile menu if open
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userLoginData = useSelector((state) => state.data.login.value);

  React.useEffect(() => {
    if (!userLoginData.token) {
      setIsLogin(false)
    } else {
      setIsLogin(true)
    }
  }, []);

  const logOut = () => {
    // Start logout loading
    setLogoutLoading(true);

    AuthApis.logout('').then(
      (response) => {
        if (response?.data) {
          dispatch(login([]))
          navigate('/');
          window.location.reload()
        }
      }
    ).catch(function (error) {
      console.log(error.response.data);
      console.log("new error");
    }).finally(() => {
      // Stop logout loading
      setLogoutLoading(false);
    });
  };

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const toggleSubmenu = () => {
    serMenuSubMenu(isMenuSubMenu === false ? true : false)
  }

  return (
    <div className="">
      <nav className="bg-[#FFFFFF] border border-b-[#E1E1E1] w-screen md:w-full max-h-screen overflow-y-auto md:h-auto md:overflow-visible fixed z-20 top-0 left-0 px-2 py-2 font-body">
        <div className="flex justify-between items-center px-2 sm:px-4 mx-auto lg:px-16">

          {/* Logo Section - Always visible and properly sized */}
          <div className="flex-shrink-0 min-w-0">
            <NavLink to="/">
              <img src="/images/AFRIPAY PNG LOGO 1.svg" alt="logo" className="h-7 sm:h-8 w-auto" />
            </NavLink>
          </div>

          {/* Desktop Menu - Hidden on mobile, centered with proper spacing */}
          <div className="hidden lg:flex items-center justify-center flex-1 mx-4 xl:mx-8">
            <div className="flex items-center space-x-1 xl:space-x-3 2xl:space-x-4">
              {/* Products */}
              <div className="relative" onMouseEnter={() => setToggle(true)} onMouseLeave={() => { setToggle(false); setHoveredProduct(null); }}>
                <NavLink
                  className="flex items-center pb-2 pt-2 px-3 xl:px-4 text-[#525252] text-sm lg:text-base font-display font-semibold hover:bg-[#209D5A] hover:text-[#ffffff] hover:rounded-xl leading-6 whitespace-nowrap transition-all duration-300 hover:shadow-lg"
                  style={({ isActive }) =>
                    isActive ? { fontWeight: "600" } : {}
                  }
                >
                  Products
                  <svg className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:rotate-180" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </NavLink>

                <div className={`${toggle ? 'flex' : 'hidden'} py-2 pl-5 bg-white absolute -bottom-30 -left-28 mx-4 my-0 rounded-[10px] shadow-gray-400 shadow-md z-50`} style={{ minWidth: hoveredProduct ? '920px' : '570px' }}>
                  <div className='font-body grid grid-cols-2 justify-between gap-1 py-2'>
                    <NavLink to={"/global-account"}>
                      <div
                        className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300"
                        onMouseEnter={() => setHoveredProduct('global')}
                      >
                        <img src="/images/multi-currency-accounts-link.png" alt="Multi-Currency Accounts" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Multi-Currency Accounts</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">Access worldwide banking services</p>
                        </div>
                      </div>
                    </NavLink>

                    <NavLink to={"/money-transfer"}>
                      <div
                        className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300"
                        onMouseEnter={() => setHoveredProduct('moneyTransfer')}
                      >
                        <img src="/images/cash-transfer-link.png" alt="Cash Transfer" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Cash Transfer</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">Send and receive money instantly</p>
                        </div>
                      </div>
                    </NavLink>

                    <NavLink to={"/currency-converter"}>
                      <div
                        className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300"
                        onMouseEnter={() => setHoveredProduct('exchange')}
                      >
                        <img src="/images/currency-exchange-link.png" alt="Currency Exchange" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Currency Exchange</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">Real-time rates for conversion</p>
                        </div>
                      </div>
                    </NavLink>

                    <NavLink to={"/bills-payment"}>
                      <div
                        className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300"
                        onMouseEnter={() => setHoveredProduct('bill')}
                      >
                        <img src="/images/bill-payments-link.png" alt="Bill/Tax Payments" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Bill/Tax Payments</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">Payments at scale, hassle-free</p>
                        </div>
                      </div>
                    </NavLink>

                    <NavLink to={"https://sandbox-business.goafripay.com/"}>
                      <div
                        className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300"
                        onMouseEnter={() => setHoveredProduct('business')}
                      >
                        <img src="/images/afripay-business-link.png" alt="AfriPay Business" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">For Business</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">Afripay solutions for your business</p>
                        </div>
                      </div>
                    </NavLink>

                    <NavLink to={"/vitual-card-page"}>
                      <div
                        className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300"
                        onMouseEnter={() => setHoveredProduct('card')}
                      >
                        <img src="/images/afripay-card-link.png" alt="AfriPay Card" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">AfriPay Card</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">Digital card for your digital life</p>
                        </div>
                      </div>
                    </NavLink>

                    <NavLink to={"/book-flight"}>
                      <div
                        className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300"
                        onMouseEnter={() => setHoveredProduct('bookFlight')}
                      >
                        <img src="/images/afripay-flight-link.png" alt="Flight Booking" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Flight Booking</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">Find unbeatable deals for your travel journey</p>
                        </div>
                      </div>
                    </NavLink>

                    <NavLink to={"/health-travel-insurance"}>
                      <div
                        className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300"
                        onMouseEnter={() => setHoveredProduct('insurance')}
                      >
                        <img src="/images/afripay-insurance-link.png" alt="Health Insurance" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Health Insurance</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">Stay protected with our insurance services</p>
                        </div>
                      </div>
                    </NavLink>
                  </div>

                  {/* Promotional Card Section */}
                  {hoveredProduct && (
                    <div className="border-l border-gray-200 pl-6 w-[345px] h-[400px] flex items-center justify-center">

                      {hoveredProduct === 'global' && (
                        <div className="rounded-xl w-[300px] h-[380px] overflow-hidden">
                          <img
                            src="/images/promo-globalAcct.avif"

                            alt="Tuition Payment"
                            className="w-full h-full object-cover"
                          />

                        </div>
                      )}

                      {hoveredProduct === 'loan' && (
                        <div className="rounded-xl w-[300px] h-[380px] overflow-hidden">
                          <img
                            src="/images/promo-studyLoan4.avif"
                            alt="Tuition Payment"
                            className="w-full h-full object-cover"
                          />


                        </div>
                      )}

                      {hoveredProduct === 'exchange' && (
                        <div className="rounded-xl w-[300px] h-[380px] overflow-hidden">

                          <img
                            src="/images/promo-exchange.avif"
                            alt="Tuition Payment"
                            className="w-full h-full object-cover"
                          />
                        </div>
                      )}

                      {/* Add similar cards for other products */}
                      {hoveredProduct === 'coin' && (
                        <div className="rounded-xl w-[300px] h-[380px] overflow-hidden">
                          <img
                            src="/images/promo-coin.avif"
                            alt="Tuition Payment"
                            className="w-full h-full object-cover"
                          />

                        </div>
                      )}

                      {hoveredProduct === 'card' && (
                        <div className="rounded-xl w-[300px] h-[380px] overflow-hidden">

                          <img
                            src="/images/promo-USD.avif"
                            alt="Tuition Payment"
                            className="w-full h-full object-cover"
                          />
                        </div>
                      )}

                      {hoveredProduct === 'business' && (
                        <div className="rounded-xl w-[300px] h-[380px] overflow-hidden">

                          <img
                            src="/images/promo-business.avif"
                            alt="Tuition Payment"
                            className="w-full h-full object-cover"
                          />
                        </div>
                      )}

                      {hoveredProduct === 'insurance' && (
                        <div className="rounded-xl w-[300px] h-[380px] overflow-hidden">
                          <img
                            src="/images/promo-insurance.avif"
                            alt="Tuition Payment"
                            className="w-full h-full object-cover"
                          />

                        </div>
                      )}

                      {hoveredProduct === 'bill' && (
                        <div className="rounded-xl w-[300px] h-[380px] overflow-hidden">

                          <img
                            src="/images/promo-bill.avif"
                            alt="Tuition Payment"
                            className="w-full h-full object-cover"
                          />

                        </div>
                      )}

                      {hoveredProduct === 'tuitionPayment' && (
                        <div className="rounded-xl w-[300px] h-[380px] overflow-hidden">
                          <img
                            src="/images/promo-tuition.avif"
                            alt="Tuition Payment"
                            className="w-full h-full object-cover"
                          />

                        </div>
                      )}

                      {hoveredProduct === 'moneyTransfer' && (
                        <div className="rounded-xl w-[300px] h-[380px] overflow-hidden">
                          <img
                            src="/images/promo-moneyTransfer.avif"
                            alt="Money Transfer"
                            className="w-full h-full object-cover"
                          />

                        </div>
                      )}

                      {hoveredProduct === 'discover' && (
                        <div className="flex flex-col items-center justify-between gap-3 w-[300px] h-[380px]">
                          <NavLink to={'/students'} className="rounded-xl w-full flex-1 overflow-hidden">
                            <img
                              src="/images/promo-forStudents.avif"
                              alt="Students"
                              className="w-full h-full object-cover"
                            />
                          </NavLink>

                          <NavLink to={'/freelancers'} className="rounded-xl w-full flex-1 overflow-hidden">
                            <img
                              src="/images/promo-forFreelancers.avif"
                              alt="Freelancers"
                              className="w-full h-full object-cover"
                            />
                          </NavLink>
                        </div>
                      )}

                      {hoveredProduct === 'bookFlight' && (
                        <div className="rounded-xl w-[300px] h-[380px] overflow-hidden">
                          <img
                            src="/images/promo-bookFlight.avif"
                            alt="Book Flight"
                            className="w-full h-full object-cover"
                          />

                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* Company */}
              <div className="relative" onMouseOut={() => setToggleTwo((prev) => (!prev))} onMouseOver={() => setToggleTwo((prev) => (!prev))}>
                <NavLink
                  className="flex items-center pb-2 pt-2 px-3 xl:px-4 text-[#525252] text-sm lg:text-base font-display font-semibold hover:bg-[#209D5A] hover:text-[#ffffff] hover:rounded-xl leading-6 whitespace-nowrap transition-all duration-300 hover:shadow-lg"
                  style={({ isActive }) =>
                    isActive ? { fontWeight: "600" } : {}
                  }
                >
                  Company
                  <svg className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:rotate-180" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </NavLink>

                <div className={`${toggleTwo ? 'flex' : 'hidden'} py-2 pl-5 bg-white absolute -bottom-30 -left-28 mx-4 my-0 min-w-[300px] rounded-[10px] shadow-gray-400 shadow-md z-50`}>
                  <div className='font-body grid grid-cols-1 gap-1 py-2'>
                    <NavLink to={"/about-us"}>
                      <div className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300">
                        <img src="/images/about-afripay-link.png" alt="About Afripay" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">About AfriPay</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">Learn more about us</p>
                        </div>
                      </div>
                    </NavLink>
                    <NavLink to={"/terms-of-use"}>
                      <div className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300">
                        <img src="/images/terms-of-service-link.png" alt="Terms of Service" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Terms of Service</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">The guidelines that govern our partnership with you</p>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                </div>
              </div>

              {/* Resources */}
              <div className="relative" onMouseOut={() => setToggleThree((prev) => (!prev))} onMouseOver={() => setToggleThree((prev) => (!prev))}>
                <NavLink
                  className="flex items-center pb-2 pt-2 px-3 xl:px-4 text-[#525252] text-sm lg:text-base font-display font-semibold hover:bg-[#209D5A] hover:text-[#ffffff] hover:rounded-xl leading-6 whitespace-nowrap transition-all duration-300 hover:shadow-lg"
                  style={({ isActive }) =>
                    isActive ? { fontWeight: "600" } : {}
                  }
                >
                  Resources
                  <svg className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:rotate-180" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </NavLink>

                <div className={`${toggleThree ? 'flex' : 'hidden'} py-2 pl-5 bg-white absolute -bottom-30 -left-28 mx-4 my-0 min-w-[300px] rounded-[10px] shadow-gray-400 shadow-md z-50`}>
                  <div className='font-body grid grid-cols-1 gap-1 py-2'>
                    <NavLink to={"/faq"}>
                      <div className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300">
                        <img src="/images/faqs-link.png" alt="FAQs" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">FAQs</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">We have answers to your questions</p>
                        </div>
                      </div>
                    </NavLink>
                    <NavLink to={"/blog"}>
                      <div className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300">
                        <img src="/images/blog-link.png" alt="Blog" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Blog</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">Stay informed with the latest news, tips, and innovations</p>
                        </div>
                      </div>
                    </NavLink>
                    <NavLink to={"/contact-us"}>
                      <div className="flex space-x-3 bg-white rounded-[12px] p-3 cursor-pointer hover:bg-gray-50 transition-colors duration-300">
                        <img src="/images/support-link.png" alt="Support" width={56} height={56} className="w-14 h-14 flex-shrink-0" />
                        <div className="pt-2">
                          <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Support</h3>
                          <p className="text-[11px] w-[173px] text-[#57575A] font-body font-[400]">We're here to help</p>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                </div>
              </div>


              {/* <NavLink
                to="/about-us"
                className="block pb-2 pt-2 px-3 xl:px-4 text-[#525252] text-sm lg:text-base font-display font-semibold hover:bg-[#209D5A] hover:text-[#ffffff] hover:rounded-xl leading-6 whitespace-nowrap transition-all duration-300 hover:shadow-lg"
                style={({ isActive }) =>
                  isActive ? { fontWeight: "600" } : {}
                }
              >
                About
              </NavLink> */}

              {/* <NavLink
                to="/afripay-app-waiting-list"
                className="block pb-2 pt-2 px-3 xl:px-4 text-[#525252] text-sm lg:text-base font-display font-semibold hover:bg-[#209D5A] hover:text-[#ffffff] hover:rounded-xl leading-6 whitespace-nowrap transition-all duration-300 hover:shadow-lg"
                style={({ isActive }) =>
                  isActive ? { fontWeight: "600" } : {}
                }
              >
                AfriPay&nbsp;App
              </NavLink> */}
              {/* <NavLink
                to="/currency-converter"
                className="block pb-2 pt-2 px-3 xl:px-4 text-[#525252] text-sm lg:text-base font-display font-semibold hover:bg-[#209D5A] hover:text-[#ffffff] hover:rounded-xl leading-6 whitespace-nowrap transition-all duration-300 hover:shadow-lg"
                style={({ isActive }) =>
                  isActive ? { fontWeight: "600" } : {}
                }
              >
                Live&nbsp;Rate
              </NavLink> */}


            </div>
          </div>

          {/* Right section - Auth buttons and user menu */}
          <div className="flex items-center flex-shrink-0 ml-2">
            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                type="button"
                className="inline-flex items-center p-1.5 text-sm rounded-lg"
              >
                <span className="sr-only">Open main menu</span>
                {!isOpen ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="#1db459" d="M4 18q-.425 0-.713-.288T3 17q0-.425.288-.713T4 16h16q.425 0 .713.288T21 17q0 .425-.288.713T20 18H4Zm0-5q-.425 0-.713-.288T3 12q0-.425.288-.713T4 11h16q.425 0 .713.288T21 12q0 .425-.288.713T20 13H4Zm0-5q-.425 0-.713-.288T3 7q0-.425.288-.713T4 6h16q.425 0 .713.288T21 7q0 .425-.288.713T20 8H4Z" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="#1db459" d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6L6.4 19Z" />
                  </svg>
                )}
              </button>
            </div>

            {/* Desktop Auth section */}
            {userLoginData?.name ? (
              <div className="hidden lg:flex items-center space-x-2 xl:space-x-3">
                <NavLink to={"/dashboard"}>
                  <button type="button" className="text-[#ffffff] bg-[#209D5A] hover:bg-[#0a3d26] border-none font-body font-semibold rounded-lg text-sm px-3 xl:px-4 py-1.5 xl:py-2 transition-all duration-300 hover:scale-105">
                    Go&nbsp;to&nbsp;Dashboard
                  </button>
                </NavLink>

                <div className="flex items-center space-x-1 xl:space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => setToggleUserName((prev) => (!prev))} width="32" height="32" viewBox="0 0 32 32">
                    <path fill="none" d="M8.007 24.93A4.996 4.996 0 0 1 13 20h6a4.996 4.996 0 0 1 4.993 4.93a11.94 11.94 0 0 1-15.986 0M20.5 12.5A4.5 4.5 0 1 1 16 8a4.5 4.5 0 0 1 4.5 4.5" />
                    <path fill="#6e7093" d="M26.749 24.93A13.99 13.99 0 1 0 2 16a13.899 13.899 0 0 0 3.251 8.93l-.02.017c.07.084.15.156.222.239c.09.103.187.2.28.3c.28.304.568.596.87.87c.092.084.187.162.28.242c.32.276.649.538.99.782c.044.03.084.069.128.1v-.012a13.901 13.901 0 0 0 16 0v.012c.044-.031.083-.07.128-.1c.34-.245.67-.506.99-.782c.093-.08.188-.159.28-.242c.302-.275.59-.566.87-.87c.093-.1.189-.197.28-.3c.071-.083.152-.155.222-.24ZM16 8a4.5 4.5 0 1 1-4.5 4.5A4.5 4.5 0 0 1 16 8M8.007 24.93A4.996 4.996 0 0 1 13 20h6a4.996 4.996 0 0 1 4.993 4.93a11.94 11.94 0 0 1-15.986 0" />
                  </svg>

                  <div onClick={() => setToggleUserName((prev) => (!prev))} className="flex items-center space-x-1 cursor-pointer relative">
                    <h3 className="text-sm text-[#525252] font-body font-medium">{(userLoginData?.name)?.split(' ')[0]}</h3>
                    <span>
                      {toggleUserName ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                          <path fill="#6E7093" d="m16.9 13.4l-4.2-4.2c-.4-.4-1-.4-1.4 0l-4.2 4.2c-.4.4-.4 1 0 1.4s1 .4 1.4 0l3.5-3.5l3.5 3.5c.2.2.4.3.7.3c.3 0 .5-.1.7-.3c.4-.4.4-1 0-1.4z" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                          <path fill="#6E7093" d="M12 15.121a.997.997 0 0 1-.707-.293L7.05 10.586a1 1 0 0 1 1.414-1.414L12 12.707l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.242a.997.997 0 0 1-.707.293Z" />
                        </svg>
                      )}
                    </span>
                  </div>

                  {toggleUserName && (
                    <div className="absolute top-full right-0 -bottom-30 min-w-[100px] bg-white border border-gray-100 rounded-md shadow-lg z-50">
                      <div className="py-3 px-4 ">
                        <div className="mb-3 text-sm cursor-pointer hover:text-[#209D5A] font-body font-medium transition-colors duration-300">
                          <NavLink to="/profilee">Profile</NavLink>
                        </div>
                        <div className="text-sm cursor-pointer hover:text-[#209D5A] font-body font-medium transition-colors duration-300" onClick={onOpenModal}>
                          Log Out
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="hidden md:flex items-center space-x-4">
                <button
                  onClick={onOpenDownload}
                  type="button" className="text-[#ffffff] bg-[#0B7F47] hover:bg-[#0a3d26] border-2 border-[#7FBC51] shadow-sm font-body font-semibold rounded-xl text-sm p-3.5 transition-all duration-300">
                  Get started — it's free
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Mobile Menu */}
        <Transition
          show={isOpen}
          enter="transition ease-out duration-500 transform"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="transition ease-in duration-400 transform"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          {(ref) => (
            <div className="md:hidden bg-white w-full px-6 py-3" id="mobile-menu">
              <div ref={ref} className="pt-3 pb-2 space-y-1">
                {/* <NavLink
                  to="/"
                  onClick={() => setIsOpen(!isOpen)}
                  className="block text-[#525252] py-2 font-display font-semibold hover:bg-gray-100 transition-colors duration-300"
                >
                  Home
                </NavLink>
                <hr className="pb-3" /> */}

                {/* Products */}
                <NavLink
                  onClick={() => setToggle((prev) => (!prev))}
                  className="text-[#525252] py-3 font-body font-medium hover:text-[#0F5132] transition-colors duration-300"
                >
                  <div className="flex justify-between pb-3 pt-2">
                    <span>Products</span>
                    <span>
                      {toggle ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path fill="currentColor" d="m16.9 13.4l-4.2-4.2c-.4-.4-1-.4-1.4 0l-4.2 4.2c-.4.4-.4 1 0 1.4s1 .4 1.4 0l3.5-3.5l3.5 3.5c.2.2.4.3.7.3c.3 0 .5-.1.7-.3c.4-.4.4-1 0-1.4z" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M12 15.121a.997.997 0 0 1-.707-.293L7.05 10.586a1 1 0 0 1 1.414-1.414L12 12.707l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.242a.997.997 0 0 1-.707.293Z" />
                        </svg>
                      )}
                    </span>
                  </div>
                </NavLink>

                {toggle && (
                  <div className="p-1 bg-white">
                    <div className="font-poppins flex flex-col">
                      <div>
                        <h2 className="text-[#637381] text-sm font-semibold mb-5">Banking & Accounts</h2>
                        <NavLink to="/currency-converter" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/currency-exchange-link.png" alt="Currency Exchange" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Currency Exchange</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">Real-time rates for conversion</p>
                            </div>
                          </div>
                        </NavLink>
                        <NavLink to="/global-account" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/multi-currency-accounts-link.png" alt="Multi-Currency Accounts" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Multi-Currency Accounts</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">Access worldwide banking services</p>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                      <div>
                        <h2 className="text-[#637381] text-sm font-semibold mb-5">Payments & Transfers</h2>
                        <NavLink to="/money-transfer" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/cash-transfer-link.png" alt="Cash Transfer" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Cash Transfer</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">Send and receive money instantly</p>
                            </div>
                          </div>
                        </NavLink>
                        <NavLink to="/bills-payment" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/bill-payments-link.png" alt="Bill/Tax Payments" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Bill/Tax Payments</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">Payments at scale, hassle-free, Instant airtime for less</p>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                      <div>
                        <h2 className="text-[#637381] text-sm font-semibold mb-5">Cards & Business</h2>
                        <NavLink to="https://sandbox-business.goafripay.com/" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/afripay-business-link.png" alt="AfriPay Business" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">For Business</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">Afripay solutions for your business</p>
                            </div>
                          </div>
                        </NavLink>
                        <NavLink to="/vitual-card-page" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/afripay-card-link.png" alt="AfriPay Card" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">AfriPay Card</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">Digital card for your digital life</p>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                      <div>
                        <h2 className="text-[#637381] text-sm font-semibold mb-5">Support & Services</h2>
                        <NavLink to="/book-flight" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/afripay-flight-link.png" alt="AfriPay Card" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Flight Booking</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">Find unbeatable deals for your travel journey</p>
                            </div>
                          </div>
                        </NavLink>
                        <NavLink to="/health-travel-insurance" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/afripay-insurance-link.png" alt="AfriPay Card" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Health Insurance</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">Stay protected with our insurance services</p>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                    </div>
                  </div>
                )}
                <hr className="pb-3" />

                {/* <NavLink
                  to="/book-flight"
                  onClick={() => setIsOpen(!isOpen)}
                  className="block text-[#525252] py-2 font-body font-medium hover:bg-gray-100 hover:text-[#0F5132] transition-colors duration-300"
                >
                  Book Flight
                </NavLink>
                <hr className="pb-3" />

                <NavLink
                  to="/health-travel-insurance"
                  onClick={() => setIsOpen(!isOpen)}
                  className="block text-[#525252] py-2 font-body font-medium hover:bg-gray-100 hover:text-[#0F5132] transition-colors duration-300"
                >
                  Health & Travel Insurance
                </NavLink>
                <hr className="pb-3" />

                <NavLink
                  to="/about-us"
                  onClick={() => setIsOpen(!isOpen)}
                  className="block text-[#525252] py-2 font-body font-medium hover:bg-gray-100 hover:text-[#0F5132] transition-colors duration-300"
                >
                  About
                </NavLink>
                <hr className="pb-3" />

                {/* <NavLink
                  to="/afripay-app-waiting-list"
                  onClick={() => setIsOpen(!isOpen)}
                  className="block text-[#525252] py-2 font-body font-medium hover:bg-gray-100 hover:text-[#0F5132] transition-colors duration-300"
                >
                  AfriPay App
                </NavLink>
                <hr className="pb-3" /> */}

                <NavLink
                  onClick={() => setToggleTwo((prev) => (!prev))}
                  className="text-[#525252] py-3 font-body font-medium hover:text-[#0F5132] transition-colors duration-300"
                >
                  <div className="flex justify-between pb-3 pt-2">
                    <span>Company</span>
                    <span>
                      {toggleTwo ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path fill="currentColor" d="m16.9 13.4l-4.2-4.2c-.4-.4-1-.4-1.4 0l-4.2 4.2c-.4.4-.4 1 0 1.4s1 .4 1.4 0l3.5-3.5l3.5 3.5c.2.2.4.3.7.3c.3 0 .5-.1.7-.3c.4-.4.4-1 0-1.4z" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M12 15.121a.997.997 0 0 1-.707-.293L7.05 10.586a1 1 0 0 1 1.414-1.414L12 12.707l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.242a.997.997 0 0 1-.707.293Z" />
                        </svg>
                      )}
                    </span>
                  </div>
                </NavLink>

                {toggleTwo && (
                  <div className="p-1 bg-white">
                    <div className="font-poppins flex flex-col">
                      <div>
                        <NavLink to="/about-us" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/about-afripay-link.png" alt="About AfriPay" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">About AfriPay</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">Learn more about us</p>
                            </div>
                          </div>
                        </NavLink>
                        <NavLink to="/terms-of-use" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/terms-of-service-link.png" alt="Terms of Service" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Terms of Service</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">The guidelines that govern our partnership with you</p>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                    </div>
                  </div>
                )}
                <hr className="pb-3" />

                {/* Resources */}
                <NavLink
                  onClick={() => setToggleThree((prev) => (!prev))}
                  className="text-[#525252] py-3 font-body font-medium hover:text-[#0F5132] transition-colors duration-300"
                >
                  <div className="flex justify-between pb-3 pt-2">
                    <span>Resources</span>
                    <span>
                      {toggleThree ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path fill="currentColor" d="m16.9 13.4l-4.2-4.2c-.4-.4-1-.4-1.4 0l-4.2 4.2c-.4.4-.4 1 0 1.4s1 .4 1.4 0l3.5-3.5l3.5 3.5c.2.2.4.3.7.3c.3 0 .5-.1.7-.3c.4-.4.4-1 0-1.4z" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M12 15.121a.997.997 0 0 1-.707-.293L7.05 10.586a1 1 0 0 1 1.414-1.414L12 12.707l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.242a.997.997 0 0 1-.707.293Z" />
                        </svg>
                      )}
                    </span>
                  </div>
                </NavLink>

                {toggleThree && (
                  <div className="p-1 bg-white">
                    <div className="font-poppins flex flex-col">
                      <div>
                        <NavLink to="/faq" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/faqs-link.png" alt="FAQs" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">FAQs</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">We have answers to your questions</p>
                            </div>
                          </div>
                        </NavLink>
                        <NavLink to="/blog" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/blog-link.png" alt="Blog" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Blog</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">Stay informed with the latest news, tips, and innovations</p>
                            </div>
                          </div>
                        </NavLink>
                        <NavLink to="/contact-us" onClick={() => { setIsOpen(!isOpen); setToggle(false) }}>
                          <div className="flex items-center gap-3 mb-3">
                            <img src="/images/support-link.png" alt="Support" width={40} height={40} />
                            <div>
                              <h3 className="text-sm text-[#0a0a0a] font-display font-semibold">Support</h3>
                              <p className="text-[11px] w-[173px] text-[#637381] font-body font-[400]">We're here to help</p>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                    </div>
                  </div>
                )}
                <hr className="pb-3" />

                {/* Mobile Auth Section */}
                {isLogin ? (
                  <div className="flex flex-col space-y-4 pt-4">
                    <NavLink to={"/dashboard"}>
                      <button type="button" className="w-full text-[#ffffff] bg-[#209D5A] hover:bg-[#016E33] border-none font-medium rounded-[5px] text-sm px-[14px] py-2.5 transition-colors duration-300">
                        Go to Dashboard
                      </button>
                    </NavLink>

                    <div className="flex items-center space-x-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                        <path fill="none" d="M8.007 24.93A4.996 4.996 0 0 1 13 20h6a4.996 4.996 0 0 1 4.993 4.93a11.94 11.94 0 0 1-15.986 0M20.5 12.5A4.5 4.5 0 1 1 16 8a4.5 4.5 0 0 1 4.5 4.5" />
                        <path fill="#6e7093" d="M26.749 24.93A13.99 13.99 0 1 0 2 16a13.899 13.899 0 0 0 3.251 8.93l-.02.017c.07.084.15.156.222.239c.09.103.187.2.28.3c.28.304.568.596.87.87c.092.084.187.162.28.242c.32.276.649.538.99.782c.044.03.084.069.128.1v-.012a13.901 13.901 0 0 0 16 0v.012c.044-.031.083-.07.128-.1c.34-.245.67-.506.99-.782c.093-.08.188-.159.28-.242c.302-.275.59-.566.87-.87c.093-.1.189-.197.28-.3c.071-.083.152-.155.222-.24ZM16 8a4.5 4.5 0 1 1-4.5 4.5A4.5 4.5 0 0 1 16 8M8.007 24.93A4.996 4.996 0 0 1 13 20h6a4.996 4.996 0 0 1 4.993 4.93a11.94 11.94 0 0 1-15.986 0" />
                      </svg>

                      <div onClick={() => setToggleUserName((prev) => (!prev))} className="flex items-center space-x-2 cursor-pointer relative">
                        <h3 className="text-sm text-[#525252] font-body font-medium">{(userLoginData?.name)?.split(' ')[0]}</h3>
                        <span>
                          {toggleUserName ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                              <path fill="#6E7093" d="m16.9 13.4l-4.2-4.2c-.4-.4-1-.4-1.4 0l-4.2 4.2c-.4.4-.4 1 0 1.4s1 .4 1.4 0l3.5-3.5l3.5 3.5c.2.2.4.3.7.3c.3 0 .5-.1.7-.3c.4-.4.4-1 0-1.4z" />
                            </svg>
                          ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                              <path fill="#6E7093" d="M12 15.121a.997.997 0 0 1-.707-.293L7.05 10.586a1 1 0 0 1 1.414-1.414L12 12.707l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.242a.997.997 0 0 1-.707.293Z" />
                            </svg>
                          )}
                        </span>
                      </div>

                      {toggleUserName && (
                        <div className="absolute bottom-24 left-0 bg-white border border-gray-100 rounded-md shadow-lg z-50">
                          <div className="py-3 px-4 min-w-[120px]">
                            <div className="mb-3 text-sm cursor-pointer hover:text-[#0F5132] font-body font-medium transition-colors duration-300">
                              <NavLink to="/profilee">Profile</NavLink>
                            </div>
                            <div className="text-sm cursor-pointer hover:text-[#0F5132] font-body font-medium transition-colors duration-300" onClick={onOpenModal}>
                              Log Out
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="flex space-x-5 pt-2">
                    <button
                      onClick={onOpenDownload}
                      className="block text-[#ffffff] bg-[#0B7F47] border-2 border-[#7FBC51] font-medium shadow-sm rounded-lg text-sm p-3.5">
                      Get started — it's free
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </Transition>
      </nav>

      {/* Logout Modal */}
      <Modal open={open} onClose={onCloseModal} center styles={{
        modal: {
          borderRadius: '15px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        },
      }}>
        <div className='md:max-w-md body-font font-poppins'>
          <div className="flex flex-col mt-2">
            <div className="flex justify-center">
              <svg width="70" height="70" viewBox="0 0 91 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.3409 91.9999C7.49716 91.9999 5.0636 90.9999 3.04023 88.9997C1.01686 86.9996 0.00344697 84.5922 0 81.7777V10.2222C0 7.41111 1.01341 5.00548 3.04023 3.00533C5.06705 1.00518 7.50061 0.0034074 10.3409 0H41.3636C42.8286 0 44.0574 0.490667 45.0502 1.472C46.0429 2.45333 46.5375 3.66637 46.5341 5.11111C46.5306 6.55585 46.0343 7.77059 45.045 8.75533C44.0557 9.74007 42.8286 10.229 41.3636 10.2222H10.3409V81.7777H41.3636C42.8286 81.7777 44.0574 82.2684 45.0502 83.2497C46.0429 84.231 46.5375 85.4441 46.5341 86.8888C46.5306 88.3336 46.0343 89.5483 45.045 90.533C44.0557 91.5178 42.8286 92.0067 41.3636 91.9999H10.3409ZM73.2912 51.1111H36.1932C34.7282 51.1111 33.5011 50.6204 32.5118 49.6391C31.5225 48.6577 31.0262 47.4447 31.0227 46C31.0193 44.5552 31.5156 43.3422 32.5118 42.3609C33.508 41.3795 34.7351 40.8889 36.1932 40.8889H73.2912L63.5966 31.3055C62.6487 30.3685 62.1747 29.2185 62.1747 27.8555C62.1747 26.4926 62.6487 25.3 63.5966 24.2778C64.5445 23.2555 65.7509 22.7223 67.2159 22.678C68.6809 22.6337 69.9304 23.1244 70.9645 24.15L89.4489 42.4222C90.4829 43.4444 91 44.637 91 46C91 47.3629 90.4829 48.5555 89.4489 49.5777L70.9645 67.8499C69.9304 68.8722 68.7033 69.3628 67.2831 69.3219C65.863 69.2811 64.6341 68.7478 63.5966 67.7222C62.6487 66.7 62.1971 65.4869 62.2419 64.0831C62.2867 62.6792 62.7814 61.5071 63.7258 60.5666L73.2912 51.1111Z" fill="#FF212E" />
              </svg>
            </div>

            <div className="mt-4">
              <h5 className="text-[15px] text-[#979797]">Are you sure you want to log out?</h5>
            </div>

            <div className='flex mt-3 space-x-2'>
              <button
                type='button'
                onClick={onCloseModal}
                className="bg-[#00B07B] text-white mt-3 font-medium rounded-[5px] text-[12px] w-full py-2.5 text-center"
              >
                Cancel
              </button>

              <button
                type='button'
                onClick={logOut}
                className="bg-[#FF212E] text-[#fff] mt-3 font-medium rounded-[5px] text-[12px] w-full py-2.5 text-center"
              >
                {logoutLoading ? ("Logging out...") : (
                  'Log Out'
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Navbar